import React, { useState } from 'react';
import {
  Typography,
  Modal,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Grid,
} from '@mui/material';
import { InfoIcon } from '../../../assets/icons/icons';

// Games Info Cell Component with Modal
const GamesInfoCell = ({ value }) => {
  const [open, setOpen] = useState(false);
  const [games, setGames] = useState([]);

  const handleOpen = () => {
    try {
      // Parse if it's a JSON string
      const parsedGames = typeof value === 'string' ? JSON.parse(value) : value;
      setGames(Array.isArray(parsedGames) ? parsedGames : []);
      setOpen(true);
    } catch (error) {
      console.error('Error parsing games:', error);
      setGames([]);
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  // Show all games (include quantity 0; display uses game.display or fallback)
  const gamesToShow = Array.isArray(games) ? games : [];

  return (
    <>
      <Button
        size='small'
        onClick={handleOpen}
        disabled={!value}
        startIcon={<InfoIcon />}
        sx={{
          color: 'var(--vega-blue)',
          textTransform: 'none',
          fontFamily: 'BrightstarSans-Regular',
        }}
      >
        View Games
      </Button>
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '90%', sm: '70%', md: '60%' },
            maxHeight: '80vh',
            overflowY: 'auto',
            bgcolor: 'var(--dust-white)',
            p: 4,
            borderRadius: 2,
            boxShadow: 24,
          }}
        >
          <Grid container spacing={2}>
            <Grid
              size={12}
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Typography
                variant='h6'
                sx={{ fontFamily: 'BrightstarSans-Regular', fontSize: '25px' }}
              >
                Games Selection
              </Typography>
              <Button
                variant='contained'
                sx={{ backgroundColor: 'var(--vega-blue)' }}
                onClick={handleClose}
              >
                Close
              </Button>
            </Grid>
            <Grid size={12}>
              {gamesToShow.length > 0 ? (
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ fontFamily: 'BrightstarSans-Bold' }}>
                          Game Display
                        </TableCell>
                        <TableCell sx={{ fontFamily: 'BrightstarSans-Bold' }}>
                          Quantity
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {gamesToShow.map((game, index) => (
                        <TableRow key={index}>
                          <TableCell>{game.display ?? game.gameName ?? 'N/A'}</TableCell>
                          <TableCell>{game.quantity != null ? game.quantity : 'N/A'}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <Typography sx={{ fontFamily: 'BrightstarSans-Regular' }}>
                  No games selected
                </Typography>
              )}
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </>
  );
};

export default GamesInfoCell;
